import { useCallback } from 'react';
import { LeadPushtoD2C } from '@/utils/leadPushUtils';
import { getDealerID } from '@/utils/dealerDataUtils';
import { logger } from '@/utils/logger';
import { supabase } from '@/integrations/supabase/client';

// Global type extension for lead push history logging
declare global {
  interface Window {
    leadPushHistory?: Array<{
      timestamp: string;
      contactData: any;
      success: boolean;
      source: string;
      error?: string;
    }>;
  }
}

// Define ContactData interface to match useContactExtraction 
interface ContactData {
  Name?: string;
  Phone?: string;
  Email?: string;
}

export const useLeadPushing = () => {
  // HTML staff notification removed: D2C CRM handles notifications after
  // the REST push. The former sendLeadNotification helper has been deleted.



  const pushLead = useCallback(async (contactData: ContactData, interestData?: any, formData?: any, formType?: string): Promise<boolean> => {
    logger.log('🔥 === SINGLE POINT D2C LEAD PUSH STARTING ===');
    logger.log('🔥 Source: FORM_SUBMISSION_HANDLER');
    logger.log('🔥 ⚠️ This should be the ONLY place leads are pushed from!');
    
    try {
      const success = await LeadPushtoD2C(contactData, interestData);
      
      logger.log('🔥 === SINGLE POINT D2C PUSH RESULT ===');
      logger.log('🔥 Success:', success);
      
      if (success) {
        logger.log('✅ Form submission successfully pushed to D2C');
        
        // Get current conversation from session manager (use async for encrypted sessions)
        const { sessionManager } = await import('../utils/sessionManager');
        const session = await sessionManager.getCurrentSessionAsync();
        const conversation = session?.messages || [];
        
        // Note: Lead notification is now handled by FormSubmissionService with proper form emails
        // No need to send notification here as it's handled upstream with correct email routing
        
        // Also log to a global tracking object for debugging
        if (!window.leadPushHistory) {
          window.leadPushHistory = [];
        }
        window.leadPushHistory.push({
          timestamp: new Date().toISOString(),
          contactData: contactData,
          success: true,
          source: 'form_submission_handler_single_point'
        });
        logger.log('🔥 Lead push history updated:', window.leadPushHistory);
      } else {
        logger.warn('⚠️ Form submission push to D2C failed or was skipped (likely duplicate)');
      }
      
      return success;
    } catch (error) {
      console.error('💥 Push lead error:', error);
      logger.error('🔥 💥 Error in push lead:', error);
      return false;
    }
  }, []);

  return {
    pushLead
  };
};